import React, { useState, useEffect } from "react";
import { Formik, Field, Form } from "formik";
import {
    FieldWrappers,
    SubmitBtn,
    SideCancelBtn,
    Wrapper,
    ScrollableContent,
    ActionSection,
} from "../Styles/InputStyles";
import tw from "tailwind-styled-components";
import * as Yup from "yup";
import { MdClose } from "react-icons/md";

const EditBasicDetail = ({
    setEditBasicDetail,
    editBasicDetailMutate,
    editBasicDetailLoading,
    selectedData,
}) => {

    const [height, setHeight] = useState(window.innerHeight);

    useEffect(() => {
        const handleResize = () => {
            setHeight(window.innerHeight); // updates when Safari UI changes
        };
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    const initialValues = {
        assetId: selectedData?.id,
        quantity: selectedData?.total,
        description: selectedData?.description,
    };
    const validationSchema = Yup.object({
        quantity: Yup.number()
            .required("Quantity is required")
            .min(1, "Units should not be less than 1")
            .max(10000, "Units should be less than 10000"),
    });

    const handleSubmit = (values) => {
        editBasicDetailMutate({
            assetId: selectedData?.id,
            description: values.description,
            count: Number(values.quantity),

        });
    };
    const handleClose = () => {
        setEditBasicDetail(false)
    }
    
    return (
        <Container style={{ height: `${height}px`, overflow: 'auto', WebkitOverflowScrolling: 'touch' }}>
            <Header>
                <h1 className="text-white text-lg font-medium">Edit Basic Detail</h1>
                <button onClick={handleClose}>
                    <MdClose color="white" size={24} />
                </button>
            </Header>
            <div className="px-6 h-full flex flex-col justify-between">
                <Formik
                    initialValues={initialValues}
                    onSubmit={handleSubmit}
                    validationSchema={validationSchema}
                    enableReinitialize
                >
                    {({ values, setFieldValue, errors, touched }) => (
                        <Form>
                            <ScrollableContent>
                                <Wrapper>
                                    <InputGroup>
                                        <Label htmlFor="quantity">Total Units *</Label>
                                        <FieldWrappers>
                                            <Field
                                                type="text"
                                                id="quantity"
                                                name="quantity"
                                                inputMode="numeric"
                                                value={values.quantity}
                                                autoComplete="off"
                                                onKeyPress={(e) => {
                                                    if (!/[0-9]/.test(e.key)) {
                                                        e.preventDefault();
                                                    }
                                                }}
                                                maxLength={10}
                                            />
                                        </FieldWrappers>
                                        {touched.quantity && errors.quantity && (
                                            <ErrorText>{errors.quantity}</ErrorText>
                                        )}
                                    </InputGroup>

                                    <InputGroup>
                                        <Label htmlFor="description">Description </Label>

                                        <Field
                                            as={Textarea}
                                            id="description"
                                            name="description"
                                            rows={5}
                                            placeholder="Enter Description (e.g., Serial Number or Product Specifications)"
                                        />
                                    </InputGroup>
                                </Wrapper>
                            </ScrollableContent>
                            <ActionSection>
                                <SideCancelBtn type="button" onClick={handleClose}>Cancel</SideCancelBtn>
                                <SubmitBtn type="submit" disabled={editBasicDetailLoading}>
                                    {editBasicDetailLoading ? "Submitting..." : "Submit"}
                                </SubmitBtn>
                            </ActionSection>
                        </Form>
                    )}
                </Formik>
            </div>
        </Container>
    );
};

const Textarea = tw.textarea`min-h-10 max-h-40 border border-gray-300 rounded pl-2 py-2 focus:ring-1 focus:ring-sky-600  focus:border-sky-600 focus:outline-none duration-200 w-full h-20 resize-y break-words overflow-hidden`;
const ErrorText = tw.div`text-red-500 text-sm ml-0.5`;
const InputGroup = tw.div`w-full flex flex-col mt-2 md:mt-0`;
const Label = tw.label`text-sm text-gray-600 font-normal mb-1.5`;
const Container = tw.div`bg-white w-full h-full flex flex-col relative`;
const Header = tw.div`flex items-center justify-between bg-[#26A69A] py-4 px-4`;

export default EditBasicDetail;
